import { render, staticRenderFns } from "./ModernSampleDetailMobile.vue?vue&type=template&id=52235509&scoped=true"
import script from "./ModernSampleDetailMobile.vue?vue&type=script&lang=js"
export * from "./ModernSampleDetailMobile.vue?vue&type=script&lang=js"
import style0 from "./ModernSampleDetailMobile.vue?vue&type=style&index=0&id=52235509&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52235509",
  null
  
)

export default component.exports